import { createSlice } from "@reduxjs/toolkit";

const radioData = {
  data: {
    "wireless.radio": [
      {
        "band": "2",
        "chanWidth": "Auto",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "7b7efa33-84ab-4006-a01e-b4908bb09758",
        "pscChannels": null,
        "rssiThreshold": null,
        "rssiThresholdEnable": false,
        "txPower": 99,
        "version": 1,
        "wirelessMode": "Auto"
      },
      {
        "band": "5",
        "chanWidth": "Auto",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "9280b891-1a41-4023-8d5d-9792a7de32c8",
        "pscChannels": null,
        "rssiThreshold": null,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 1,
        "wirelessMode": "Auto"
      },
      {
        "band": "6",
        "chanWidth": "Auto",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "ffc52d84-3591-4d04-873e-a5cebc51957e",
        "pscChannels": null,
        "rssiThreshold": null,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 1,
        "wirelessMode": "Auto"
      }
    ],
    "wireless.radioGlobal": {
      "id": "f9f51570-9f2c-4bd6-b830-7e5bd8e7aba4",
      "neighborApDetection": false,
      "neighborApDetectionSchedule": [],
      "version": 1
    }
  }
};

export const radioSlice = createSlice({
  name: "radio",
  initialState: radioData,
  reducers: {
    setRadioData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setRadioData } = radioSlice.actions;

export default radioSlice.reducer;
